import React from 'react';
import EditorDelete from '@wix/da-ds/pkg/Icons/24x24/EditorDelete';
import { ButtonProps } from '../../../../components/menus/buttons/types';
import { useTranslation } from 'react-i18next';

import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';

const Delete: React.FC<ButtonProps> = ({ editor }) => {
  const { t } = useTranslation('editor');
  return (
    <EditorIconButton
      featureId="node:video:delete"
      icon={EditorDelete}
      onClick={() => editor.chain().focus().daVideoDelete().run()}
      tooltipText={t('ext.video.button.delete')}
      aria-label={t('ext.video.button.delete')}
    />
  );
};
Delete.displayName = 'Delete';

export default Delete;
